import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DatePicker from '../../wui-datepicker/src';
import zhCN from '../../wui-datepicker/src/locale/zh_CN';
import FormControl from '../../wui-input/src';
import Select from '../../wui-select/src';
import InputNumber from '../../wui-input-number/src';
import FilterDropDown from './FilterDropDown';
var RangePicker = DatePicker.RangePicker,
    YearPicker = DatePicker.YearPicker,
    MonthPicker = DatePicker.MonthPicker,
    WeekPicker = DatePicker.WeekPicker;
var propTypes = {
  filterDropdown: PropTypes.string
};

var FilterType = /*#__PURE__*/function (_Component) {
  _inherits(FilterType, _Component);

  var _super = _createSuper(FilterType);

  function FilterType(props) {
    var _this;

    _classCallCheck(this, FilterType);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "clearFilter", function () {
      var _this$props = _this.props,
          onFilterClear = _this$props.onFilterClear,
          dataIndex = _this$props.dataIndex;

      if (_this.state.value !== "") {
        _this.setState({
          value: "",
          //清空值
          condition: _this.props.filterDropdownType == 'string' ? 'LIKE' : 'EQ' //切回默认查询条件

        }, function () {
          //调用清除方法参数为当前字段的field
          onFilterClear && onFilterClear(dataIndex);
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "changeText", function (val) {
      var _this$props2 = _this.props,
          onFilterChange = _this$props2.onFilterChange,
          dataIndex = _this$props2.dataIndex;

      _this.setState({
        value: val
      }, function () {
        onFilterChange(dataIndex, val, _this.state.condition);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "changeTextCall", function (e) {
      var _this$props3 = _this.props,
          onFilterChange = _this$props3.onFilterChange,
          dataIndex = _this$props3.dataIndex;

      if (e.keyCode == 13) {
        e.target.value !== "" && onFilterChange(dataIndex, e.target.value, _this.state.condition);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "changeValue", function () {
      _this.setState({
        value: ""
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSelectDropdown", function (item) {
      var _this$props4 = _this.props,
          onFilterChange = _this$props4.onFilterChange,
          dataIndex = _this$props4.dataIndex;

      _this.setState({
        condition: item.key
      }, function () {
        _this.state.value !== "" && onFilterChange && onFilterChange(dataIndex, _this.state.value, _this.state.condition);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "changeNumber", function (value) {
      var _this$props5 = _this.props,
          onFilterChange = _this$props5.onFilterChange,
          dataIndex = _this$props5.dataIndex;

      _this.setState({
        value: value
      }, function () {
        onFilterChange(dataIndex, value, _this.state.condition);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "clearNumber", function () {
      var onChange = _this.props.onChange;
      onChange && onChange("");

      _this.setState({
        value: ""
      });
    });

    _defineProperty(_assertThisInitialized(_this), "changeTextCallBlur", function (val) {
      var onChange = _this.props.onChange;
      onChange && onChange(val);
    });

    _defineProperty(_assertThisInitialized(_this), "changeSelect", function (value) {
      var _this$props6 = _this.props,
          onFilterChange = _this$props6.onFilterChange,
          dataIndex = _this$props6.dataIndex;

      if (onFilterChange) {
        onFilterChange(dataIndex, value, _this.state.condition);

        _this.setState({
          value: value
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "clearSelectValue", function () {
      _this.setState({
        selectValue: ""
      }, function () {
        _this.changeSelect("");
      });
    });

    _defineProperty(_assertThisInitialized(_this), "clearDateValue", function () {
      _this.setState({
        dateValue: ""
      }, function () {
        _this.changeDate("");
      });
    });

    _defineProperty(_assertThisInitialized(_this), "changeDate", function (value) {
      var _this$props7 = _this.props,
          onFilterChange = _this$props7.onFilterChange,
          dataIndex = _this$props7.dataIndex;

      if (onFilterChange) {
        onFilterChange(dataIndex, value, _this.state.condition);

        _this.setState({
          value: value,
          open: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderControl", function (rendertype) {
      var _this$props8 = _this.props,
          filterInputNumberOptions = _this$props8.filterInputNumberOptions,
          filterDropdownIncludeKeys = _this$props8.filterDropdownIncludeKeys,
          dataIndex = _this$props8.dataIndex,
          filterDropdown = _this$props8.filterDropdown,
          filterDropdownType = _this$props8.filterDropdownType,
          format = _this$props8.format,
          className = _this$props8.className,
          onChange = _this$props8.onChange,
          onSelectDropdown = _this$props8.onSelectDropdown,
          clsPrefix = _this$props8.clsPrefix,
          locale = _this$props8.locale;

      switch (rendertype) {
        case 'text':
          return /*#__PURE__*/React.createElement("div", {
            className: "".concat(clsPrefix, " filter-wrap")
          }, /*#__PURE__*/React.createElement(FormControl, {
            value: _this.state.value,
            className: className,
            onChange: _this.changeText,
            onKeyDown: _this.changeTextCall //onBlur={this.changeTextCallBlur}

          }), /*#__PURE__*/React.createElement(FilterDropDown, {
            locale: locale,
            dataIndex: dataIndex,
            dataText: _this.state.value,
            onSelectDropdown: _this.onSelectDropdown,
            onClickClear: _this.clearFilter,
            isShowClear: _this.state.value,
            isShowCondition: filterDropdown,
            filterDropdownType: filterDropdownType,
            filterDropdownIncludeKeys: filterDropdownIncludeKeys
          }));

        case 'number':
          return /*#__PURE__*/React.createElement("div", {
            className: "".concat(clsPrefix, " filter-wrap")
          }, /*#__PURE__*/React.createElement(InputNumber, _extends({}, filterInputNumberOptions, {
            className: className,
            value: _this.state.value,
            onChange: _this.changeNumber,
            iconStyle: "one"
          })), /*#__PURE__*/React.createElement(FilterDropDown, {
            locale: locale,
            dataIndex: dataIndex,
            dataText: _this.state.value,
            onSelectDropdown: _this.onSelectDropdown,
            onClickClear: _this.clearFilter,
            isShowClear: _this.state.value != 0,
            isShowCondition: filterDropdown,
            filterDropdownType: filterDropdownType,
            filterDropdownIncludeKeys: filterDropdownIncludeKeys
          }));

        case 'dropdown':
          return /*#__PURE__*/React.createElement("div", {
            className: "".concat(clsPrefix, " filter-wrap")
          }, /*#__PURE__*/React.createElement(Select, _extends({}, _this.props, {
            size: "sm",
            value: _this.state.value,
            onChange: _this.changeSelect
          })), /*#__PURE__*/React.createElement(FilterDropDown, {
            locale: locale,
            dataIndex: dataIndex,
            dataText: _this.state.value,
            onSelectDropdown: _this.onSelectDropdown,
            onClickClear: _this.clearFilter,
            isShowCondition: filterDropdown,
            isShowClear: _this.state.value,
            filterDropdownType: filterDropdownType,
            filterDropdownIncludeKeys: filterDropdownIncludeKeys
          }));

        case 'date':
          return /*#__PURE__*/React.createElement("div", {
            className: "".concat(clsPrefix, " filter-wrap")
          }, /*#__PURE__*/React.createElement(DatePicker, _extends({}, _this.props, {
            value: _this.state.value,
            onChange: _this.changeDate,
            open: _this.state.open,
            format: format,
            locale: zhCN
          })), /*#__PURE__*/React.createElement(FilterDropDown, {
            locale: locale,
            dataIndex: dataIndex,
            dataText: _this.state.value,
            onSelectDropdown: _this.onSelectDropdown,
            onClickClear: _this.clearFilter,
            isShowCondition: filterDropdown,
            isShowClear: _this.state.value,
            filterDropdownType: filterDropdownType,
            filterDropdownIncludeKeys: filterDropdownIncludeKeys
          }));

        case 'dateyear':
          return /*#__PURE__*/React.createElement("div", {
            className: "".concat(clsPrefix, " filter-wrap")
          }, /*#__PURE__*/React.createElement(YearPicker, _extends({}, _this.props, {
            value: _this.state.value,
            onChange: _this.changeDate,
            open: _this.state.open,
            format: format,
            locale: zhCN
          })), /*#__PURE__*/React.createElement(FilterDropDown, {
            locale: locale,
            dataIndex: dataIndex,
            dataText: _this.state.value,
            onSelectDropdown: _this.onSelectDropdown,
            onClickClear: _this.clearFilter,
            isShowCondition: filterDropdown,
            isShowClear: _this.state.value,
            filterDropdownType: filterDropdownType,
            filterDropdownIncludeKeys: filterDropdownIncludeKeys
          }));

        case 'datemonth':
          return /*#__PURE__*/React.createElement("div", {
            className: "".concat(clsPrefix, " filter-wrap")
          }, /*#__PURE__*/React.createElement(MonthPicker, _extends({}, _this.props, {
            value: _this.state.value,
            onChange: _this.changeDate,
            open: _this.state.open,
            format: format,
            locale: zhCN
          })), /*#__PURE__*/React.createElement(FilterDropDown, {
            locale: locale,
            dataIndex: dataIndex,
            dataText: _this.state.value,
            onSelectDropdown: _this.onSelectDropdown,
            onClickClear: _this.clearFilter,
            isShowCondition: filterDropdown,
            isShowClear: _this.state.value,
            filterDropdownType: filterDropdownType,
            filterDropdownIncludeKeys: filterDropdownIncludeKeys
          }));

        case 'dateweek':
          return /*#__PURE__*/React.createElement("div", {
            className: "".concat(clsPrefix, " filter-wrap")
          }, /*#__PURE__*/React.createElement(WeekPicker, _extends({}, _this.props, {
            value: _this.state.value,
            onChange: _this.changeDate,
            open: _this.state.open,
            format: format,
            locale: zhCN
          })), /*#__PURE__*/React.createElement(FilterDropDown, {
            locale: locale,
            dataIndex: dataIndex,
            dataText: _this.state.value,
            onSelectDropdown: _this.onSelectDropdown,
            onClickClear: _this.clearFilter,
            isShowCondition: filterDropdown,
            isShowClear: _this.state.value,
            filterDropdownType: filterDropdownType,
            filterDropdownIncludeKeys: filterDropdownIncludeKeys
          }));

        case 'daterange':
          return /*#__PURE__*/React.createElement("div", {
            className: "".concat(clsPrefix, " filter-wrap")
          }, /*#__PURE__*/React.createElement(RangePicker, _extends({}, _this.props, {
            value: _this.state.value,
            onChange: _this.changeDate,
            open: _this.state.open,
            format: format,
            showTime: true,
            locale: zhCN,
            placeholder: '开始 ~ 结束',
            dateInputPlaceholder: ['开始', '结束'],
            showClear: true
          })), /*#__PURE__*/React.createElement(FilterDropDown, {
            locale: locale,
            dataIndex: dataIndex,
            dataText: _this.state.value,
            onSelectDropdown: _this.onSelectDropdown,
            onClickClear: _this.clearFilter,
            isShowCondition: filterDropdown,
            isShowClear: _this.state.value,
            filterDropdownIncludeKeys: filterDropdownIncludeKeys
          }));

        case 'bool':
          return /*#__PURE__*/React.createElement("div", {
            className: "".concat(clsPrefix, " filter-wrap")
          }, /*#__PURE__*/React.createElement(Switch, {
            className: className,
            onChange: onChange
          }), /*#__PURE__*/React.createElement(FilterDropDown, {
            locale: locale,
            onSelectDropdown: onSelectDropdown,
            filterDropdownIncludeKeys: filterDropdownIncludeKeys
          }));

        default:
          return /*#__PURE__*/React.createElement("div", null);
      }
    });

    _this.state = {
      value: "",
      text: "",
      selectValue: "",
      dateValue: "",
      open: false,
      condition: props.filterDropdownType == 'string' ? 'LIKE' : 'EQ',
      number: 0
    };
    return _this;
  }
  /**
   * 清除过滤条件
   *
   */


  _createClass(FilterType, [{
    key: "render",
    value: function render() {
      var rendertype = this.props.rendertype;
      return /*#__PURE__*/React.createElement("div", {
        "data-filter-type": "filterContext"
      }, this.renderControl(rendertype));
    }
  }]);

  return FilterType;
}(Component);

FilterType.propTypes = propTypes;
FilterType.defaultProps = {
  filterDropdown: 'show'
};
export default FilterType;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-table/src/FilterType.js